module.exports = __webpack_public_path__ + "img/homestart.ba25954c.png";